import { mv } from './mv';
import { campagin } from './campagin';
import { menu } from './menu';
mv();
campagin();
menu();
